import React, { useEffect, useRef, useState } from 'react'
import { clone } from '../../features/utils/objClone';

export default function OTPInput(props) {
  const {n=6,onChange,value: defValue,callback,...restProps} = props;
  const [value,setValue] = useState(defValue?defValue?.split('') : [...Array(n)]);
  const inputRefs = useRef([...Array(n)])

  useEffect(() => {
    onChange && onChange(value.join(''))
    if(value?.every(val => val && val !==''))
      callback && callback(value.join(''))
  },[value])

  function handleValue(ev,i=0) {
    const val = ev.target.value;
    const temp = clone(value);
    temp[i] = val;
    
    if(val!=='' && i+1 < inputRefs?.current.length)
      inputRefs.current[i+1].focus();

    setValue(temp);
  }
  function handleBackspace(ev,i=0) {
    const temp = clone(value);

    if(ev.key === 'Backspace') {
      temp[i] = "";
  
      if(i-1 >= 0 && (inputRefs.current[i].value === ""))
        inputRefs.current[i-1].focus();

      setValue(temp);
    } 

    // if(value?.every(val => val && val !==''))
    //   callback && callback(value.join(''))
  }

  function handlePaste(e) {
    e.preventDefault();

    const pastedText = e.clipboardData.getData('text/plain');
    setValue((pastedText||'')?.split('')?.slice(0,n))
  }
  
  return (
    <div className='flex gap-2 w-full'>
      {value.map((val,i) => (
        <div className='flex-1'>
          <input type='text' 
            {...restProps}
            key={i} value={val||''} maxLength={1} tabIndex={i+1} 
            ref={(el) => inputRefs.current[i] = el} 
            onKeyDown={(ev) => handleBackspace(ev,i)}
            onChange={(ev) => handleValue(ev,i)}
            onPaste={(ev) => handlePaste(ev)}
            className='border border-primary/20 rounded-lg w-full h-[50px] p-1 sm:p-3 text-[20px] text-center'
          />
        </div>
      ))}
    </div>
  )
}
